export default {"src":"/_next/static/media/confetti-outline-dark.7a5f5346.gif","height":400,"width":400};